document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ filter-search-page.js loaded with chevron intact");

  function addSearchToFilters() {
    const allGroups = document.querySelectorAll(".sidebarBlock.js-filter");

    allGroups.forEach(group => {
      const ul = group.querySelector("ul.facets__list, ul[data-filter-group]");
      if (!ul || group.querySelector(".custom-filter-search")) return;

      const input = document.createElement("input");
      input.type = "text";
      input.placeholder = "Search options…";
      input.className = "custom-filter-search";
      input.setAttribute("autocomplete", "off");
      input.style.cssText =
        "margin-bottom:10px; padding:6px; width:100%; box-sizing:border-box; border:1px solid #ccc; border-radius:5px;";

      ul.parentNode.insertBefore(input, ul);

      input.addEventListener("input", function () {
        const searchVal = input.value.toLowerCase().trim();
        let anyVisible = false;

        ul.querySelectorAll("li").forEach(li => {
          const label = li.innerText.toLowerCase().trim();
          const match = label.includes(searchVal);
          li.style.display = match ? "" : "none";
          if (match) anyVisible = true;
        });

        const oldMsg = group.querySelector(".no-filter-match-msg");
        if (oldMsg) oldMsg.remove();

        if (!anyVisible && searchVal !== "") {
          const msg = document.createElement("div");
          msg.className = "no-filter-match-msg";
          msg.textContent = "No results found.";
          msg.style.cssText = "padding: 8px 0; color: #888; font-style: italic;";
          ul.parentNode.appendChild(msg);
        }
      });
    });
  }

  function collapseFiltersByRemovingOpenClass() {
    document.querySelectorAll(".sidebarBlock.open").forEach(block => {
      block.classList.remove("open");
    });
  }

  function runAll() {
    collapseFiltersByRemovingOpenClass();
    addSearchToFilters();
  }

  // Initial run
  setTimeout(runAll, 300);

  // Re-run after Shopify AJAX loads (e.g., filtering)
  document.addEventListener("shopify:section:load", () => {
    setTimeout(runAll, 300);
  });

  const observer = new MutationObserver(() => {
    setTimeout(runAll, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

